module.exports = __webpack_public_path__ + "static/media/map-square.416ec78c.png";